export default "__VITE_ASSET__ZxXLj6Kt__"